import { isEmpty } from "ramda";
import { FILTER_UNSET } from "../../constants";
import { displayCascadeValue, getDefaultStatus, propIsNull, transformViewOptionPropData } from "../../shared";
/**
 * 通过视图分组新增节点时，新节点的继承数据
 * @param {*} condition 视图筛选条件
 * @param {*} groupBy 视图分组条件
 * @param groupData 分组数据
 * @param template 模板数据
 */
export const getAddNodeDataWithViewOption = (condition, groupBy = '', groupData, template, groupKey = '', brotherNode) => {
  groupBy = groupBy || '';
  groupData = groupData || {};
  // 过滤项和分组项都是下面的可选
  // templateStatus 状态
  // templateProp_${tempId}_${index} 模板属性
  // templateStatusPropBase_${index} 基础状态属性4个
  // templateStatusPropCustom_${tempId}_${status}_${index} 其他状态属性
  // sysCreator || _sys_creator 创建人
  // _sys_createTime 创建时间

  // 先处理需要变更的数据到 changeFields
  const changeFields = [];
  // 1.过滤项
  condition.map((x, i) => {
    if (!x || x.key === 'templateId' || ~x.key.indexOf('_sys') && x.key !== '_sys_tag' || x.key === 'sysCreator' || isEmpty(x.value)) {
      // 模板id和系统属性不需要处理
      return;
    }
    const conditionValue = Array.isArray(x.value) ? x.value.filter(a => a !== FILTER_UNSET) : [x.value];
    if (!conditionValue.length) return;
    if (x.key === 'templateStatus') {
      let value = conditionValue[0];
      changeFields.push({
        type: 'templateStatus',
        value: Number(value.split('_')[1]),
        orgin: 'condition'
      });
    }
    // condition属性
    if (~x.key.indexOf('templateProp_')) {
      const [_, __, propIndex] = x.key.split('_');
      const propInfo = template.prop[Number(propIndex)];

      // transformViewOptionPropData 可能返回多个需要被修改的值（公式计算源）
      const needChangeValues = transformViewOptionPropData(template, Number(propIndex), propInfo, conditionValue, brotherNode?.tempInfo?.prop || []);
      needChangeValues.map(x => {
        const propConfig = template.prop[x.propIndex];
        const field = {
          type: 'templateProp',
          value: x.value,
          index: x.propIndex,
          orgin: 'condition'
        };
        if (propConfig?.type === 'cascade') {
          // 多级选值要添加 _sys_cascade
          const titles = displayCascadeValue({
            value: x.value,
            cascadeMap: propConfig?.cascade?.nodesMap,
            multiple: propConfig.multiple,
            hideRoutes: propConfig.hideRoutes
          });
          field['sysCascade'] = titles;
        }
        changeFields.push(field);
      });
      // changeFields.push({
      //   type: 'templateProp',
      //   value:transformViewOptionPropData(template,propIndex,propInfo,conditionValue),
      //   index: propIndex,
      //   orgin: 'condition',
      // });
    }
    if (~x.key.indexOf('templateStatusPropBase_')) {
      const [_, propIndex] = x.key.split('_');
      if (Number(propIndex) < 2) {
        // 只有负责人和参与者需要继承
        changeFields.push({
          type: 'tempStatusProp',
          value: conditionValue,
          index: propIndex,
          orgin: 'condition'
        });
      }
    }
    // 模板状态属性，需要在确定状态的时候，才能赋值
    if (~x.key.indexOf('templateStatusPropCustom_')) {
      const [_, __, ___, propIndex] = x.key.split('_');
      changeFields.push({
        type: 'tempStatusProp',
        index: propIndex,
        value: conditionValue,
        orgin: 'condition'
      });
    }
    // 系统标签
    if (x.key === '_sys_tag') {
      const tags = x.value || [];
      changeFields.push({
        type: '_sys_tag',
        orgin: 'condition',
        value: tags
      });
    }
  });
  if (groupData?.list?.length) {
    // 2.分组项
    if (groupBy === 'templateStatus') {
      let value = !groupData.info ? 0 : groupData.info.status;
      changeFields.push({
        type: 'templateStatus',
        value,
        orgin: 'groupBy'
      });
    }
    if (~groupBy.indexOf('templateProp_')) {
      if (groupKey && groupKey !== 'default') {
        const [_, __, propIndex] = groupBy.split('_');
        const propInfo = template.prop[Number(propIndex)];
        changeFields.push({
          type: 'templateProp',
          index: propIndex,
          value: propInfo.multiple ? [groupKey] : groupKey,
          orgin: 'groupBy'
        });
      }
    }
    // 模板状态属性，需要在确定状态的时候，才能赋值
    if (~groupBy.indexOf('templateStatusPropBase_')) {
      // 人员
      const [_, propIndex] = groupBy.split('_');
      let value = Number.isFinite(Number(propIndex)) ? groupData.list[0].prop._sys_task_status.prop[Number(propIndex)] : null;
      if (!propIsNull(value)) {
        changeFields.push({
          type: 'tempStatusProp',
          index: propIndex,
          value: value,
          orgin: 'groupBy'
        });
      }
    }
    if (~groupBy.indexOf('templateStatusPropCustom_')) {
      const [_, propIndex] = groupBy.split('_');
      let value = Number.isFinite(propIndex) ? groupData.list[0].prop._sys_task_status.prop[Number(propIndex)] : null;
      if (!propIsNull(value)) {
        changeFields.push({
          type: 'tempStatusProp',
          index: propIndex,
          value: value,
          orgin: 'groupBy'
        });
      }
    }
    if (groupBy === '_sys_tag' && groupData.name && groupData.name !== '未定义') {
      changeFields.push({
        type: '_sys_tag',
        orgin: 'groupBy',
        value: [groupData.name]
      });
    }
  }

  // set template prop
  let tempProp = null;
  let sysCascade = null;
  const changeTempProp = changeFields.filter(x => x.type === 'templateProp');
  if (changeTempProp.length) {
    tempProp = new Array(template.prop.length).fill(null);
    changeTempProp.map(option => {
      tempProp[Number(option.index)] = option.value;
      if (option.sysCascade) {
        if (!sysCascade) {
          sysCascade = {};
        }
        sysCascade[option.index] = option.sysCascade;
      }
    });
  }
  // status
  let status = null;
  const changeStatus = changeFields.filter(x => x.type === 'templateStatus');
  if (changeStatus.length) {
    // 默认的状态，以分组为主
    if (groupBy === 'templateStatus' && groupData.list) {
      const changeStatusByGroup = changeStatus.find(x => x.orgin === 'groupBy');
      status = changeStatusByGroup?.value;
    } else {
      status = changeStatus[0].value;
    }
  } else if (Array.isArray(template.task_status) && template.task_status.find(x => x && !x.disabled)) {
    status = getDefaultStatus(template);
  }
  // status prop
  let statusProp = null;
  const changeStatusProp = changeFields.filter(x => x.type === 'tempStatusProp');
  if (changeStatusProp.length) {
    if (status !== null) {
      const tempStatusConfig = template.task_status[status];
      statusProp = new Array(tempStatusConfig.prop.length).fill(null);
      changeStatusProp.map(option => {
        const propInfo = tempStatusConfig.prop[Number(option.index)];
        let value;
        if (propInfo.multiple) {
          value = Array.isArray(option.value) ? option.value : [option.value];
        } else {
          value = Array.isArray(option.value) && option.value.length ? option.value[0] : option.value;
        }
        statusProp[Number(option.index)] = value;
      });
    } else if (changeStatusProp.find(o => Number(o.index) < 2)) {
      statusProp = [changeStatusProp.find(o => Number(o.index) === 0)?.value || null, changeStatusProp.find(o => Number(o.index) === 1)?.value || null];
    }
  }

  // sys tag
  let sysTag = null;
  const changeSysTag = changeFields.filter(x => x.type === '_sys_tag');
  if (changeSysTag.length) {
    const tags = Array.from(new Set(changeSysTag.reduce((a, b) => {
      return a.concat(b.value);
    }, [])));
    if (tags.length) {
      sysTag = tags;
    }
  }
  const res = {};
  if (tempProp !== null) {
    res.tempProp = tempProp;
  }
  if (status !== null) {
    res.status = status;
  }
  if (statusProp !== null) {
    res.statusProp = statusProp;
  }
  if (sysTag !== null) {
    res.sysTag = sysTag;
  }
  if (sysCascade !== null) {
    res.sysCascade = sysCascade;
  }
  return res;
};